module.exports = "/images/kr.svg?4c965dbe32ff4f97e6ac942445c56bb2";